module.exports = __webpack_public_path__ + "static/media/shuffleturn-card.9e35da99.png";